import { render, staticRenderFns } from "./LeaderBoardBanner.vue?vue&type=template&id=0f993907&"
import script from "./LeaderBoardBanner.vue?vue&type=script&lang=js&"
export * from "./LeaderBoardBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports